import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from '../header_text.png';
import './HeaderText.css';

/** From Figma (195:1555) — «ЗАГРУЗКА», top 145.822 / left 389. */
export function HeaderText() {
  return (
    <SharedHeaderText
      className="loading-header-text"
      src={headerTextImg}
      alt="Загрузка"
    />
  );
}
